import { charToWordOffset, countWords, ReaderAnchor, wordOffsetToChar } from './selection';
import { ReaderBlock } from './types';

// Resolution-independent reading cursor: a chapter's blocks + a word offset
// within them. Word offsets survive font-size and screen changes, so reopening
// lands on the same word on any device. These generalize the per-segment math
// the translation reader used, over any block list keyed by block id.

// The word offset (within a chapter's blocks) of an anchor — the count of words
// before the anchor's block plus the word index of its char offset.
export function wordOffsetOfAnchor(blocks: ReaderBlock[], anchor: ReaderAnchor): number {
  let acc = 0;
  for (const b of blocks) {
    if (b.id === anchor.segmentId) return acc + charToWordOffset(b.text, anchor.charOffset);
    acc += countWords(b.text);
  }
  return acc;
}

// The anchor (block id + char offset) at a chapter-relative word offset. Returns
// null only for an empty chapter; otherwise clamps into the last block.
export function anchorOfWordOffset(blocks: ReaderBlock[], wordOffset: number): ReaderAnchor | null {
  let acc = 0;
  for (let i = 0; i < blocks.length; i += 1) {
    const wc = countWords(blocks[i].text);
    if (wordOffset < acc + wc || i === blocks.length - 1) {
      return {
        segmentId: blocks[i].id,
        charOffset: wordOffsetToChar(blocks[i].text, wordOffset - acc),
      };
    }
    acc += wc;
  }
  return null;
}
